export default __webpack_public_path__ + "static/media/thermistor.a79c7679.svg";